import { Component, inject } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import {
	TranslateService,
	TranslatePipe,
	TranslateDirective
} from "@ngx-translate/core";

import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts/core';
import { BarChart } from 'echarts/charts';
import { GridComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
echarts.use([BarChart, GridComponent, CanvasRenderer]);
import { CookieService} from 'ngx-cookie-service';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
	imports: [IonicModule, SidebarComponent, TranslatePipe],
	standalone: true,
	providers: [
		provideEchartsCore({ echarts }),
		CookieService
	]
})
export class AppComponent {

	private cookieService = inject(CookieService);
	private translate = inject(TranslateService);
	router = inject(Router);

	isLoading = true;
	currentRoute: string = '/';
	show_sidebar:boolean = false;

	is_cookie_accepted:boolean = false;

	constructor() {

		this.translate.addLangs(['es', 'en']);
		this.translate.setFallbackLang('es');
		this.translate.use('es');

		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe((event: NavigationEnd) => {
			this.currentRoute = event.urlAfterRedirects; // Ejemplo: /home
			this.isLoading = false;

			this.show_sidebar =
					this.currentRoute == '/' || 
					this.currentRoute.indexOf('/login')==0 ||
					this.currentRoute.indexOf('/recover')==0
				? false : true;
		});

		this.checkCookieConsent();
	}

	checkCookieConsent() {
		this.is_cookie_accepted = this.cookieService.check('cookieConsent');
	}

	acceptCookie() {
		this.cookieService.set('cookieConsent', 'true', 365); // expira en 1 año
		this.is_cookie_accepted = true;
	}


}
